import Application from './app/Application';
import { AuthProvider } from './AuthContext';
import { AppNavigationProvider } from './navigation/AppNavigation';
import WebShell from './platforms/web/WebShell';
import { getAuthToken } from './api';
import PublicEntry, { isPublicEntry } from './official/PublicEntry';
export type { Person } from './types/person';

export default function App() {
  let token: string | null = null;
  try { token = getAuthToken(); } catch { /* Public pages also work with storage disabled. */ }
  if (isPublicEntry(window.location.pathname, window.location.hash, token)) return <PublicEntry />;
  return (
    <AuthProvider>
      <AppNavigationProvider>
        <WebShell>
          <Application />
        </WebShell>
      </AppNavigationProvider>
    </AuthProvider>
  );
}
